export const BYOC_PARENT_TILE_ID = "byoc";

export function isByocParentTile(parentTileId: string): boolean {
  return parentTileId === BYOC_PARENT_TILE_ID;
}
